// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___LzPHp","root__text":"style-module__root__text___mfFZS","root__close":"style-module__root__close___jG4al"};
    if(module.hot) {
      // 1729151124047
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  